module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_sp_banner04-699e2505a458037fc06e0fb39f53b7e3.jpg";